
(function ($) {

	function DataLayerApi() {
		this.debug = window.location.search.match(/debug=true/);
	}

	$.extend(DataLayerApi.prototype, {
		push: function (event) {
			if (this.debug) {
				console.log('dataLayer event', event);
			}

			window.dataLayer.push(event);
		},
	});


	window.dataLayer = [];
	window.dataLayerApi = new DataLayerApi();

})(jQuery);
